import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { searchBoxStyles } from "@insite/content-library/Widgets/Addresses/AddressBookSearchBox";
import { currentBillingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentBillingAddress";
import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import Search from "@insite/mobius/Icons/Search";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

currentBillingAddressStyles.editLinkGridItem = {
    width: 0,
};

currentBillingAddressStyles.addressInfoDisplayGridItem = {
    width: 12,
    css: css`
        padding: 10px 17px;
    `,
};

currentBillingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        background-color: ${getColor("info.contrast")};
        padding: 10px 17px;
        border-radius: 4px;
    `,
};

currentBillingAddressStyles.headingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0px;
    `,
};

currentShippingAddressStyles.editLinkGridItem = {
    width: 0,
};

currentShippingAddressStyles.addressInfoDisplayGridItem = {
    width: 12,
    css: css`
        padding: 10px 17px;
    `,
};

currentShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        background-color: ${getColor("info.contrast")};
        padding: 10px 17px;
        border-radius: 4px;
    `,
};

currentShippingAddressStyles.headingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0px;
    `,
};

currentShippingAddressStyles.useBillingAddress = {
    button: {
        variant: "secondary",
        css: css`
            margin-top: 20px;
        `,
    },
};

addressBookStyles.addressCardGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0px;
    `,
};

addressBookStyles.addressCard = {
    gridContainer: {
        gap: 20,
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: 0;
                >${GridItemStyle}{
                    >address[class^="sc"] {
                        p{
                            color: ${getColor("secondary")};
                        }
                    }
                }
            }
        `,
    },
    addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
    actionsGridItem: {
        width: [2, 2, 7, 5, 5],
        css: css`
            justify-content: flex-end;
        `,
    },
    actionUseAsShippingAddressButton: {
        variant: "secondary",
    },
    actionEditLink: {
        css: css`
        display: none;
        `,
    },
    bottomBorderGridItem: { width: 12 },
    bottomBorder: {
        css: css`
            height: 1px;
            background-color: ${getColor("common.border")};
            width: 100%;
        `,
    },
    overflowMenu: {
        cssOverrides: {
            menu: css`
                width: 210px;
                > li[class^="sc"] {
                    > ${StyledButton} {
                        color: ${getColor("secondary")};
                    }
                    &:last-child {
                        // display: none;
                    }
                }
            `,
        },
    },
};

addressBookStyles.addressHeaderGridItem = {
    width: 12,
    css: css`
        padding: 10px 10px 16px 0px;
        border-bottom: 1px solid ${getColor("common.border")};
        > div[class^="Wrapper"] {
            > ${GridWrapper} {
                > ${GridOffset} {
                    > ${GridItemStyle} {
                        &:first-child {
                            padding-right: 0px;
                            > div[class^="Wrapper"] {
                                padding: 0rem 1rem;
                            }
                        }
                    }
                }
            }
        }
    `,
};

addressBookStyles.titleTextGridItem = {
    width: 12,
    css: css`
        background-color: ${getColor("info.contrast")};
        padding: 15px 17px;
        margin: 8px 0px !important;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        margin-bottom: 4px !important;
                    `,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

addressBookStyles.titleText = {
    variant: "h5",
    css: css`
        margin-bottom: 0px;
    `,
};
addressBookStyles.gridContainer = {
    gap: 20,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 0 0.5rem;
                `,
                css`
                    padding: 0 0.5rem;
                `,
                null,
                null,
                null,
            ])}
    `,
};

searchBoxStyles.searchText = {
    css: css`
        font-size: 16px !important;
        padding: 12px 35px 12px 10px !important;
        &:focus {
            padding: 12px 35px 12px 10px !important;
        }
    `,
    iconProps: { src: Search },
};
